export type Option = {
    id: string;
    text: string;
    numMonths?: number | 'all' | null;
};

export const lastSoldOptions: Option[] = [
    {
        id: 'all-time',
        text: 'All time',
        numMonths: 'all'
    },
    {
        id: '3-months',
        text: '3 months',
        numMonths: 3
    },
    {
        id: '6-months',
        text: '6 months',
        numMonths: 6
    },
    {
        id: '12-months',
        text: '12 months',
        numMonths: 12
    },
    {
        id: '5-years',
        text: '5 years',
        numMonths: 60
    },
    {
        id: '10-years',
        text: '10 years',
        numMonths: 120
    },
    {
        id: '20-years',
        text: '20 years',
        numMonths: 240
    }
];

// Todo: need functionality to support default/placeholder value
export const propertyTypeOptions: Option[] = [
    { id: 'any', text: 'Any' },
    { id: 'D', text: 'Detached' },
    { id: 'S', text: 'Semi-detached' },
    { id: 'T', text: 'Terraced' },
    { id: 'F', text: 'Flats' }
];

export const sortOptions: Option[] = [
    { id: 'address-asc', text: 'Address (A-Z)' },
    { id: 'address-desc', text: 'Address (Z-A)' },
    { id: 'sold-desc', text: 'Sold (newest - oldest)' },
    { id: 'sold-asc', text: 'Sold (oldest - newest)' },
    { id: 'price-paid-asc', text: 'Price paid (lowest - highest)' },
    { id: 'price-paid-desc', text: 'Price paid (highest - lowest)' }
];
